import script from "./ModalFormulario.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFormulario.vue?vue&type=script&setup=true&lang=js"

import "./ModalFormulario.vue?vue&type=style&index=0&id=2b3d1fb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3d1fb2"]])

export default __exports__